import {
  BaseEdge,
  EdgeLabelRenderer,
  getStraightPath,
  getBezierPath,
  useReactFlow
} from '@xyflow/react';
import Tooltip from '../Tooltip.js';
import { useState } from 'react';
import KingdomIcon from '../ReactionTable/kingdomIcon.js';
import { Link } from 'react-router-dom';
import formatMechanismStep from '../../functions/formatMechanismStep.js';

export default function ReactionEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const  [detailDisplay, setDetailDisplay] = useState(false);

   const enzymeArray = data.enzymes
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length > 0);

    const kingdomArray = data.kingdoms
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length > 0);
 
  return (
    <>
       <BaseEdge
        path={edgePath}
        markerEnd= {markerEnd} style={style}
      />
      <EdgeLabelRenderer>
        <div  className="reaction-edge-box" style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`}}
          onClick={() => {setDetailDisplay(!detailDisplay); }}
        >
          <div>{formatMechanismStep(data?.mechanism_type, data?.distance, data?.transannular) || 'Unknown'} </div>
          <div style={{ fontWeight: 'bold', fontSize: "10px"}}>
            {data.enzymes_count + " enzymes"?? 'N/A'}
          </div>
        </div> 
        {detailDisplay && (
          <div  style={{
            background: 'white',
            border: '1px solid #ccc',
            padding: '4px 8px',
            borderRadius: 6,
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            fontSize: 12,
            textAlign: 'center',
            pointerEvents: 'all',
            cursor: 'pointer',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
            zIndex: 9999
          }}
          onMouseLeave={() => setDetailDisplay(false)}
        >
          {kingdomArray.map((kingdom, index)  =>  (<KingdomIcon row={index} isQuickSearch={true} interactiveSearch={() => {}} backgroundColor="rgb(255,255,255)" kingdomVal={kingdom} speciesVal={`None`}/>))}<br/>
          {enzymeArray.map((enzyme, index) => (
           <Link to={`/record/${encodeURIComponent(enzyme)}`} className="plane-text-button" >{enzyme} {(index < enzymeArray.length - 1) ? "," : ""}</Link>))}
        </div> 
        )}
      </EdgeLabelRenderer>
    </>
  );
}